import { useState, useEffect, useRef } from "react"
import { useLocation, useHistory } from "react-router"

export default function useFetch(fn) {
  const isMounted = useRef(true)
  const [data, setData] = useState()
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState()
  const location = useLocation()
  const history = useHistory()

  useEffect(() => {
    onMount()
  }, [location.key])

  useEffect(() => {
    return () => {
      isMounted.current = false
    }
  }, [])

  function onMount() {
    try {
      const response = fn() // 🔹 Call function synchronously
      if (!isMounted.current) return
      if (response.is404) return handle404()
      if (!response.isSuccess) return handleError(response)

      setData(response)
      setIsLoading(false)
    } catch (err) {
      handleError(err)
    }
  }

  function handleError(response) {
    setIsLoading(false)
    setError(response.responseMessage)
  }

  function handle404() {
    history.push("/not-found")
  }

  return {
    data,
    isLoading,
    error,
    setData,
    setIsLoading,
    setError,
    handleError,
  }
}
